import { put, select, takeEvery } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";

import { closeDispatchingModal, ScanLabelAction } from "actions";
import { SubmitBulkScanLabelsAction } from "actions/modals/scanLabel";

import { SUBMIT_BULK_SCAN_LABELS } from "constants/actionTypes";
import { ModalTypes } from "constants/navigation";
import { ScanLabelArchetype } from "constants/scanLabels";

import { getLivestockSaleId } from "lib/navigation";
import toast from "lib/toast";

import { selectScanLabelsByScanIdLookup } from "selectors";

interface NewScanLabelPayload {
  id: string;
  scanId: string;
  name: string;
  archetype: ScanLabelArchetype;
  livestockSaleId: number;
}

function* onSubmitBulkScanLabels(action: SubmitBulkScanLabelsAction) {
  const { scanIds, addLabelNames, removeLabelNames, archetypeByLabelName } =
    action;

  const scanLabelsByScanId: Record<string, ScanLabel[]> = yield select(
    selectScanLabelsByScanIdLookup,
  );
  const livestockSaleId: number = getLivestockSaleId();

  const toCreate: NewScanLabelPayload[] = [];
  const idsToDelete: string[] = [];

  scanIds.forEach(scanId => {
    const existingLabels = scanLabelsByScanId[scanId] || [];

    addLabelNames.forEach(name => {
      if (!existingLabels.some(label => label.name === name)) {
        toCreate.push({
          id: uuidv4(),
          scanId,
          name,
          archetype: archetypeByLabelName[name] || ScanLabelArchetype.NONE,
          livestockSaleId,
        });
      }
    });

    removeLabelNames.forEach(name => {
      existingLabels
        .filter(label => label.name === name)
        .forEach(label => idsToDelete.push(label.id));
    });
  });

  if (toCreate.length > 0 || idsToDelete.length > 0) {
    toast.syncing("Updating scan labels...");
  }

  if (toCreate.length > 0) {
    yield put(ScanLabelAction.createBulk(toCreate));
  }

  for (const id of idsToDelete) {
    yield put(ScanLabelAction.delete(id));
  }

  yield put(closeDispatchingModal(ModalTypes.BulkUpdateScanLabels));
}

export function* scanLabelModalSagas() {
  yield takeEvery(SUBMIT_BULK_SCAN_LABELS, onSubmitBulkScanLabels);
}
